export interface ILocationApiResponse {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  lat: number;
  lng: number;
  time_zone: string;
  active: boolean;
  location_type: string;
}

export class Location {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  lat: number;
  lng: number;
  timeZone: string;
  active: boolean;
  locationType: string;

  constructor(json: ILocationApiResponse = null) {
    if (json) {
      this.assign_attrs_from_json(json);
    }
  }

  private assign_attrs_from_json(json: ILocationApiResponse): Location {
    this.id = json.id;
    this.name = json.name;
    this.createdAt = json.created_at;
    this.updatedAt = json.updated_at;
    this.addressLine1 = json.address_line1;
    this.addressLine2 = json.address_line2;
    this.city = json.city;
    this.state = json.state;
    this.postalCode = json.postal_code;
    this.lat = json.lat;
    this.lng = json.lng;
    this.timeZone = json.time_zone;
    this.active = json.active;
    this.locationType = json.location_type;

    return this;
  }
}

export interface Locations { [index: string]: Location; }
